import { useSelector } from 'react-redux'
import { useState, useEffect } from "react";
import { Grid, Card, Alert, AlertTitle } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import StickyHeadOneButtonTable from '../components/StickyHeadOneButtonTable';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';


const columns = [
  { id: 'token', label: 'Token', align: 'left'},
  { id: 'update_time', label: 'Create Time', align: 'center'},
  { id: 'action', label: 'Data', align: 'center', action: true},
];

const VoiceQueuePage = () => {
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [showAlert, setshowAlert] = useState(false);
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});

    useEffect(() => {
        const getTestQueue = async () => {
            try {
                setshowAlert(false);
                const response = await axios.post("/peloton/v1/automation/voice-tests", null, { withCredentials: true});
                if (response.data.message === "success"){
                    if (response.data.data !== null){
                        setRows(response.data.data);
                    }else{
                        setshowAlert(true);
                    }
                }
            } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
            }
        };
        getTestQueue();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDetail = (uuid) => {

        setData(JSON.stringify(JSON.parse(uuid), null, 2));
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                {customization.login && (<StickyHeadOneButtonTable rows={rows} columns={columns} handleDetail={handleDetail} title="Tiger Voice Queue"/>)}
                {showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
                <AlertTitle>Warning</AlertTitle>
                No data in this condition.
              </Alert></Card>)}
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"JSON Data"}
                </DialogTitle>
                <DialogContent>
                    <div><pre>{data}</pre></div>
                </DialogContent>
              </Dialog>
            </Grid>
        </Grid>
    );
};

export default VoiceQueuePage;
